import { withIcon } from "../Icon"

export const IconInvoice = withIcon(
  '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.056 7.056H9.722m5.334 3.555H9.722m5.334 3.556H11.5M6.167 3.5H18.61v16l-.917-.786a1.778 1.778 0 0 0-2.314 0l-.917.786-.917-.786a1.778 1.778 0 0 0-2.314 0l-.917.786-.917-.786a1.778 1.778 0 0 0-2.314 0l-.917.786v-16Z"/>',
)
